const acusacionOptions = [
  { id: 1, name: "Acoso Escolar (Bullying Escolar)" },
  { id: 2, name: "Acoso Laboral (Bullying Laboral)" },
  { id: 3, name: "Apuestas Ilícitas" },
  { id: 4, name: "Chantaje/Extorsión" },
  { id: 5, name: "Cohecho" },
  { id: 6, name: "Concusión" },
  { id: 7, name: "Conducción Ilegal de Vehículo" },
  { id: 8, name: "Contrabando" },
  { id: 9, name: "Contaminación Sonora" },
  { id: 10, name: "Crímenes y delitos de alta tecnología" },
  { id: 11, name: "Delito contra la propiedad intelectual" },
  { id: 12, name: "Delito de medioambiente" },
  { id: 13, name: "Delito tributario" },
  {
    id: 14,
    name: "Delitos cometidos por los funcionarios públicos en el ejercicio de sus funciones",
  },
  { id: 15, name: "Delitos financieros" },
  { id: 16, name: "Desfalco" },
  { id: 17, name: "El tráfico ilícito de drogas y sustancias controladas" },
  { id: 18, name: "Enriquecimiento no justificado" },
  { id: 19, name: "Estafa agravada" },
  { id: 20, name: "Estafa contra el Estado" },
  { id: 21, name: "Estafa/Fraude" },
  { id: 22, name: "Explotación sexual de menores" },
  { id: 23, name: "Extorsión" },
  { id: 24, name: "Falsificación de alimentos y bebidas" },
  { id: 25, name: "Falsificación de documentos públicos" },
  { id: 26, name: "Falsificación de monedas, valores o títulos" },
  { id: 27, name: "Falsificación y adulteración de medicamentos" },
  { id: 28, name: "Imprudencia" },
  { id: 29, name: "Lavado de Activos" },
  { id: 31, name: "Manipulación del Mercado" },
  { id: 32, name: "Negligencia" },
  { id: 33, name: "Ocupación de Espacios Públicos" },
  { id: 34, name: "Ocupación de Propiedades Privadas" },
  { id: 35, name: "Piratería y piratería de productos" },
  { id: 36, name: "Pornografía infantil" },
  { id: 37, name: "Posesión de Arma Blanca Ilegal" },
  { id: 38, name: "Posesión de Arma de Fuego Ilegal" },
  { id: 39, name: "Posesión de Drogas" },
  { id: 40, name: "Posesión Ilegal de Vehículo" },
  { id: 41, name: "Prevaricación" },
  { id: 43, name: "Robo Agravado/Asalto" },
  { id: 44, name: "Riñas" },
  { id: 45, name: "Secuestro" },
  { id: 46, name: "Sicariato" },
  { id: 47, name: "Soborno" },
  { id: 48, name: "Soborno transnacional" },
  { id: 49, name: "Testaferrato" },
  { id: 50, name: "Terrorismo y el financiamiento al terrorismo" },
  { id: 51, name: "Tragamonedas Ilegales" },
  { id: 52, name: "Tráfico de influencia" },
  { id: 53, name: "Tráfico de inmigrantes ilegales" },
  { id: 54, name: "Tráfico ilícito de armas" },
  { id: 55, name: "Tráfico ilícito de órganos humanos" },
  { id: 56, name: "Tráfico ilícito de patrimonio histórico y cultural" },
  { id: 57, name: "Tráfico ilícito de seres humanos" },
  { id: 58, name: "Trata de personas" },
  { id: 59, name: "Uso indebido de información confidencial o privilegiada" },
  { id: 60, name: "Violencia Escolar" },
  { id: 61, name: "Violencia Intrafamiliar" },
  { id: 62, name: "Prevaricación" },
]

acusacionOptions.sort((a, b) =>
  a.name.localeCompare(b.name, "es", { sensitivity: "base" })
)
export default acusacionOptions
